var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-heading__container"},[(_vm.$slots.title || _vm.title)?_c('h1',{staticClass:"page-heading__title"},[_vm._t("title"),_vm._v(" "+_vm._s(_vm.title)+" ")],2):_vm._e(),(_vm.$slots.actions)?_c('div',{staticClass:"page-heading__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }